module.exports = __webpack_public_path__ + "static/media/icon-piece.90591dca.png";